import {createRouter, createWebHashHistory} from 'vue-router'
import AlbumView from '@/views/AlbumView.vue'
import Watermark from '@/views/watermark.vue'
import { useAlbumStore } from '@/store/album'
import { getUrlParams } from '@/utils'

const router = createRouter({
    // history: createWebHistory(import.meta.env.BASE_URL),
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            name: 'album',
            component: AlbumView,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/photoDetail',
            name: 'photoDetail',
            component: () => import('../views/PhotoDetail.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/albumFace',
            name: 'albumFace',
            component: () => import('../views/AlbumFace.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/puzzle',
            name: 'puzzle',
            component: () => import('../views/SawPuzzle.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/searchFace',
            name: 'searchFace',
            component: () => import('../views/SearchFace.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/faceResult',
            name: 'faceResult',
            component: () => import('../views/FaceResult.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/kidResult',
            name: 'kidResult',
            component: () => import('../views/KidResult.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/confirmKids',
            name: 'confirmKids',
            component: () => import('../views/ConfirmKids.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/sharePoster',
            name: 'sharePoster',
            component: () => import('../views/SharePosters.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/shareKids',
            name: 'shareKids',
            component: () => import('../views/ShareKids.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/gather',
            name: 'gather',
            component: () => import('../views/Gather.vue'),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/userHome',
            name: 'userhome',
            component: () => import('../views/HomeView.vue'),
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/404',
            name: '404',
            component: () => import('../views/404.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/networkDetection',
            name: 'networkDetection',
            component: () => import('../views/networkDetection.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/dissolveAlbum',
            name: 'dissolveAlbum',
            component: () => import('../views/dissolveAlbum/index.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/albumViewWeb',
            name: 'albumViewWeb',
            component: () => import('../views/albumViewWeb.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/openWechat',
            name: 'openWechat',
            component: () => import('../views/OpenWechat.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/watermark',
            name: 'watermark',
            component: () => import('../views/watermark.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/sellPhoto',
            name: 'sellPhoto',
            component: () => import('../views/SellPhoto.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/numberIdentify',
            name: 'numberIdentify',
            component: () => import('../views/NumberIdentify.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/numberIdentifyResult',
            name: 'numberIdentifyResult',
            component: () => import('../views/NumberIdentifyResult.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/fileNameSearch',
            name: 'fileNameSearch',
            component: () => import('../views/FileNameSearch.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/fileNameSearchResult',
            name: 'fileNameSearchResult',
            component: () => import('../views/FileNameSearchResult.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/downLoadPackage',
            name: 'downLoadPackage',
            component: () => import('../views/DownLoadPack.vue'),
            meta: {
                keepAlive: false
            }
        }
    ]
})

router.beforeEach((to, form, next) => {
    const albumStore = useAlbumStore()
    const screenWidth = window.innerWidth
    const screenHeight = window.innerHeight
    console.log('页面宽高', screenWidth, screenHeight)
    albumStore.setScreenWidth(screenWidth)
    albumStore.setScreenHeight(screenHeight)
    let params: any = getUrlParams()
    if (to.path == '/') {
        if (params.gatherId && !params.albumId) {
            next('/gather')
        }
    }
    if (form.name) {
        localStorage.setItem('formRouter', JSON.stringify(form.name))
    } else {
        localStorage.setItem('formRouter', undefined)
    }
    if (to.path === '/puzzle' && form.name !== 'album') {
        next('/')
    } else if (to.path === '/' && screenWidth > 1200) {
        // console.log('是否开启了照片付费:', albumStore.payPhotoType)
        if (albumStore.payPhotoType === 'PAY_PHOTO') {
            next('/openWechat')
        } else {
            next('/albumViewWeb')
        }
    } else if (to.path === '/albumViewWeb' && screenWidth <= 1200) {
        next('/')
    } else {
        next()
    }
})

export default router

